export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00519.643e93db.png";